import React, { useEffect, useState } from 'react'
import Spining from '../UI/Spining/Spining'
import DatePicker from 'react-datepicker';
import AdvanceDataTable from '../UI/Table/AdvanceDataTable';
import AdminLayout from '../UI/Layout/AdminLayout';
import Title from '../UI/Text/Title';
import Axios from '../../axios/Axios';
import Select from "react-select";
import { HOST_URL, NODE_HOST_URL_v1 } from '../Dashboard/api/Api';
import { userloginDetails } from '../Utils/AdminAuth';
import { EMPLOYEE_CAMPAIGN_DATA } from '../UI/Table/ColumnConst';

const ApiReport = () => {
    const lStorage = userloginDetails();
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    const adminType = lStorage.user.isAdmin;
    const username = lStorage.user.username;

    const [isLoading, setIsLoading] = useState(false);
    const [dateFilter, setDateFilter] = useState('today');
    const [fromdate, setFromdate] = useState(null);
    const [todate, setTodate] = useState(null);
    const [channel, setChannel] = useState('sms')
    const [allUsers, setAllUsers] = useState('')
    const [selecteduser, setSelectedusers] = useState("");
    const [campaignData, setCampaignData] = useState([]);
    const [totalCost, setTotalCost] = useState(null)
    const [voiceData, setVoiceData] = useState([]);
    const [smsData, setSmsData] = useState([])
    const [emailData, setEmailData] = useState([])
    const [searchData, setSearchData] = useState([]);
    const [searchUser, setSearchUser] = useState([]);
    const [totalData, setTotalData] = useState({
        Delivered: 0,
        failed: 0,
        submitted: 0,
        success: 0,
        sent: 0,
        opened: 0,
        bounced: 0,
        clicked: 0,
        read: 0,
        Other : 0
    });
    const [submitFrom , setSubmitFrom] = useState("");

    const customStyles = {
        control: (provided) => ({
            ...provided,
            cursor: "pointer",
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        option: (style) => ({
            ...style,
            fontSize: "13px",
        }),
    };


    useEffect(() => {
        const today = new Date();
        if (dateFilter === 'today') {
            setFromdate(today);
            setTodate(today);
        } else {
            setFromdate(null);
            setTodate(null);
        }
    }, [dateFilter]);

    const isOldDate = dateFilter === 'old';

    const today = new Date();
    const todayWithoutTime = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    const isDisabledDate = (date) => {
        const selected = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        return selected >= todayWithoutTime; // disables today and future dates
    };

    useEffect(() => {
        allUserList();
        CampaignReports();
    }, []);

    const userHandler = (e) => {
        setSelectedusers(e.value);
    };

    const currentDate = (currentDate) => {
        const year = currentDate?.getFullYear();
        const month = String(currentDate?.getMonth() + 1).padStart(2, "0");
        const day = String(currentDate?.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    };

    const handleChannelChange = (e) => {
        setChannel(e.target.value)
        setSearchData([]);
    }

    const allUserList = async () => {
        const parentParams = {
            user_id: userId,
            method: "retrieve",
            type: adminType,
            token: userToken
        }
        try {
            let { data } = await Axios.post(`${HOST_URL}/employee_user_list.php`, parentParams)
            if (data.success) {
                let filterData = data.data.map((x) => {
                    return ({ label: x.username, value: x.username })
                })
                setAllUsers(filterData)
                setSearchUser(data.data)
                // console.log(data.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const CampaignReports = async () => {
        let filterData = searchUser.find(x => x.id == selecteduser)
        setIsLoading(true);
        let paramData = {
            user_id: userId,
            token: userToken,
            username: username,
            method: "api_report",
            fromdate: currentDate(fromdate),
            todate: currentDate(todate),
            child_name: filterData?.username,
            channel: channel,
            filter_type: dateFilter,
            submit_from: submitFrom
        }
        try {
            let { data } = await Axios.post(`${NODE_HOST_URL_v1}/api_report`, paramData)
            if (data.success) {
                let Delivered = 0
                let failed = 0
                let submitted = 0
                let success = 0
                let sent = 0
                let opened = 0
                let bounced = 0
                let clicked = 0
                let read = 0
                let Other = 0
                if (selecteduser !== '') {
                    let filterData = data.data.filter(x => x.username == selecteduser)

                    if (channel === "rcs") {
                        filterData.map((x) => {
                            Delivered += x.delivered;
                            failed += x.failed
                            sent += x.sent
                            read += x.read
                        })
                        setTotalData({
                            Delivered: Delivered,
                            failed: failed,
                            sent: sent,
                            read: read
                        })
                    }
                    else {
                        filterData.map((x) => {
                            Delivered += x.Delivered;
                            failed += x.Failed
                            submitted += x.Submitted
                            success += x.Success
                            sent += x.Sent
                            opened += x.Opened
                            bounced += x.Bounce
                            clicked += x.Clicked
                            read += x.Read
                            Other += x.Other
                        })
                        setTotalData({
                            Delivered: Delivered,
                            failed: failed,
                            submitted: submitted,
                            success: success,
                            sent: sent,
                            opened: opened,
                            bounced: bounced,
                            clicked: clicked,
                            read: read,
                            Other : Other
                        })
                    }
                    setSearchData(filterData)
                }
                else {
                    if (channel === "rcs") {
                        data.data.map((x) => {
                            Delivered += x.delivered;
                            failed += x.failed
                            sent += x.sent
                            read += x.read
                        })
                        setTotalData({
                            Delivered: Delivered,
                            failed: failed,
                            sent: sent,
                            read: read
                        })
                    }
                    else {
                        data.data.map((x) => {
                            Delivered += x.Delivered;
                            failed += x.Failed
                            submitted += x.Submitted
                            success += x.Success
                            sent += x.Sent
                            opened += x.Opened
                            bounced += x.Bounce
                            clicked += x.Clicked
                            read += x.Read
                            Other += x.Other
                        })
                        setTotalData({
                            Delivered: Delivered,
                            failed: failed,
                            submitted: submitted,
                            success: success,
                            sent: sent,
                            opened: opened,
                            bounced: bounced,
                            clicked: clicked,
                            read: read,
                            Other: Other
                        })
                    }
                    setSearchData(data.data)
                }
            }
        } catch (error) {
            console.log(error)
        }
        setIsLoading(false);
    }

    const handleDateFilterChange = (e) => {
        setDateFilter(e.target.value)
        setSearchData([])
    }


    const headerStyle = {
        backgroundColor: '#3F3966',
        color: 'white',
        padding: '10px',
        fontSize: "13px"
    };

    return (
        <div>
            <AdminLayout>
                {/* <Title isButton={false}> API Report </Title> */}

                {(channel !== '' && searchData.length > 0) &&
                    <div className="row">
                        <div className="col-xl-12 col-xxl-5 d-flex">
                            <div className="w-100">
                                <div className="row">
                                    <div className={channel === "sms" || channel === "voice" ? "col-sm-3" : "col-sm-2"}>
                                        <div className="card">
                                            <div className="card-body p-2">
                                                <h5 className="card-title mb-0">Total Data</h5>
                                                <h6 className="mt-0 mb-0">{parseFloat((totalData.Delivered || 0) + (totalData.Other || 0) + (totalData.failed || 0) + (totalData.sent || 0) + (totalData.read || 0) + (totalData.submitted || 0) + (totalData.success || 0) + (totalData.opened || 0) + (totalData.bounced || 0) + (totalData.clicked || 0))}</h6>
                                            </div>
                                        </div>
                                    </div>
                                    {(channel === "sms" || channel === "email" || channel === "wp" || channel === "rcs") && <div className={channel === "sms" ? "col-sm-3" : "col-sm-2"}>
                                        <div className="card">
                                            <div className="card-body p-2">
                                                <h5 className="card-title mb-0">Delivered</h5>
                                                <h6 className="mt-0 mb-0">{totalData.Delivered || 0}</h6>
                                            </div>
                                        </div>
                                    </div>}
                                    {(channel === "sms" || channel === "voice" || channel === "wp" || channel === "rcs") && <div className={channel === "sms" || channel === "voice" ? "col-sm-3" : "col-sm-2"}>
                                        <div className="card">
                                            <div className="card-body p-2">
                                                <h5 className="card-title mb-0">Failed</h5>
                                                <h6 className="mt-0 mb-0">{totalData.failed || 0}</h6>
                                            </div>
                                        </div>
                                    </div>}
                                    {(channel === "wp" || channel === 'email' || channel === "rcs") && <div className="col-sm-2">
                                        <div className="card">
                                            <div className="card-body p-2">
                                                <h5 className="card-title mb-0">Sent</h5>
                                                <h6 className="mt-0 mb-0">{channel === "wp" ? (totalData.sent + totalData.submitted) : totalData.sent}</h6>
                                            </div>
                                        </div>
                                    </div>}
                                    {(channel === "wp" || channel === "rcs") &&
                                        <div className="col-sm-2">
                                            <div className="card">
                                                <div className="card-body p-2">
                                                    <h5 className="card-title mb-0"><span>Read</span></h5>
                                                    <h6 className="mt-0 mb-0">{totalData.read || 0}</h6>
                                                </div>
                                            </div>
                                        </div>}

                                         {channel === "wp" &&
                                        <div className="col-sm-2">
                                            <div className="card">
                                                <div className="card-body p-2">
                                                    <h5 className="card-title mb-0"><span>Other</span></h5>
                                                    <h6 className="mt-0 mb-0">{totalData.Other || 0}</h6>
                                                </div>
                                            </div>
                                        </div>}
                                    {/* {(channel !== "rcs" && channel !== "wp") && (
                                        <div className={channel === "sms" || channel === "voice" ? "col-sm-3" : "col-sm-2"}>
                                            <div className="card">
                                                <div className="card-body p-2">
                                                    <h5 className="card-title mb-0"><span>Submitted</span></h5>
                                                    <h6 className="mt-0 mb-0">{totalData.submitted || 0}</h6>
                                                </div>
                                            </div>
                                        </div>
                                    )} */}

                                    {channel === 'voice' &&
                                        <div className={channel === "voice" ? "col-sm-3" : "col-sm-2"}>
                                            <div className="card">
                                                <div className="card-body p-2">
                                                    <h5 className="card-title mb-0"><span>Success</span></h5>
                                                    <h6 className="mt-0 mb-0">{totalData.success || 0}</h6>
                                                </div>
                                            </div>
                                        </div>}
                                    {channel === 'email' &&
                                        <>
                                            <div className="col-sm-2">
                                                <div className="card">
                                                    <div className="card-body p-2">
                                                        <h5 className="card-title mb-0"><span>Opened</span></h5>
                                                        <h6 className="mt-0 mb-0">{totalData.opened || 0}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="card">
                                                    <div className="card-body p-2">
                                                        <h5 className="card-title mb-0"><span>Bounced</span></h5>
                                                        <h6 className="mt-0 mb-0">{totalData.bounced || 0}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="card">
                                                    <div className="card-body p-2">
                                                        <h5 className="card-title mb-0"><span>Clicked</span></h5>
                                                        <h6 className="mt-0 mb-0">{totalData.clicked || 0}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </>}
                                    {/* <div className="col-sm-2">
                                        <div className="card">
                                            <div className="card-body p-2 ">
                                                <h5 className="card-title mb-0">Total Cost</h5>
                                                <h6 className="mt-0 mb-0">
                                                    {parseFloat(totalCost).toFixed(2) || 0}
                                                </h6>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>}

                <div className="row">
                    <div className="">
                        <div className="card">
                            {/* {alert.status === true ? (
                                <div className={alert.bgColor} role="alert">
                                    <button
                                        type="button"
                                        className="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                    >
                                        <span aria-hidden="true">×</span>
                                    </button>
                                    <div className="">{alert.errorMessage}</div>
                                </div>
                            ) : null} */}

                            {isLoading && <Spining />}

                            <div className="card-body">
                                <div className="filter-option" >
                                    <div className='row mb-2'>
                                        <div className={channel === "rcs" ? 'col-3' : 'col-6'}>
                                            <h6 className="card-subtitle text-muted">
                                                <b>API Report{" "}</b>
                                            </h6>
                                        </div>
                                        {channel === "rcs" &&
                                        <div className='col-3'>
                                            <select className='form-control' value={submitFrom} onChange={(e)=>setSubmitFrom(e.target.value)}>
                                                <option value="">Select Submit From</option>
                                                <option value="PANNEL">Pannel</option>
                                                <option value="API">API</option>
                                                <option value="BULK_API">Bulk Api</option>
                                            </select>
                                        </div>}
                                        <div className='col-4'>
                                            <select value={dateFilter} className='form-control' onChange={handleDateFilterChange}>
                                                <option value="today">Today Date</option>
                                                <option value="old">Old Date</option>
                                            </select>
                                        </div>
                                        <div className='col-2'>
                                            <button type="button" className="btn btn-info" onClick={CampaignReports}>Search</button>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className={dateFilter === "old" ? "col-md-3" : "col-md-4"}>
                                            <label>Select Channel</label>
                                            <div className="input-group drop-down-icons mb-2 mr-sm-2 table1">
                                                <div className="input-group mb-2 mr-sm-2 ">
                                                    <select className='form-control' value={channel} onChange={handleChannelChange}>
                                                        <option value="">Select Channel</option>
                                                        <option value="sms">SMS</option>
                                                        <option value="voice">Voice</option>
                                                        <option value="email">Email</option>
                                                        <option value="wp">Whatsapp</option>
                                                        <option value="rcs">RCS</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        {dateFilter === "old" &&
                                            <div className="col-md-3">
                                                <label>Select User</label>
                                                <div className="input-group drop-down-icons mb-2 mr-sm-2 table1">
                                                    <div className="input-group mb-2 mr-sm-2 ">
                                                        {/* <div className="input-group-text">User </div> */}
                                                        <Select
                                                            onChange={userHandler}
                                                            options={allUsers}
                                                            isSearchable={true}
                                                            placeholder="All Users"
                                                            styles={customStyles}
                                                        // isDisabled = {channel === "rcs" ? true : false}

                                                        // isClearable
                                                        />
                                                    </div>
                                                </div>
                                            </div>}

                                        <div className={dateFilter === "old" ? "col-md-3" : "col-md-4"}>
                                            <label>From Date</label>
                                            <div className="input-group mb-2 mr-sm-2 table2">
                                                {/* <div className="input-group-text">
                          <FontAwesomeIcon icon={faCalendarAlt} />
                        </div> */}

                                                <DatePicker
                                                    className="form-control btn-block"
                                                    selected={fromdate}
                                                    onChange={(date) => setFromdate(date)}
                                                    filterDate={isOldDate ? (date) => !isDisabledDate(date) : undefined}
                                                    placeholderText="Select from date"
                                                    disabled={dateFilter === 'today'}
                                                    isClearable={isOldDate}
                                                />

                                                {/* <ReactDatePicker
                                                    className="form-control btn-block"
                                                    dateFormat="dd/MM/yyyy"
                                                    value={fromdate}
                                                    onChange={(date) => setFromdate(date)}
                                                    maxDate={isOldDate ? today : null}
                                                    disabled={dateFilter === 'today'}
                                                    selected={fromdate}
                                                    placeholderText="From Date"
                                                /> */}

                                            </div>
                                        </div>
                                        <div className={dateFilter === "old" ? "col-md-3" : "col-md-4"}>
                                            <label>To Date</label>
                                            <div className="input-group mb-2 mr-sm-2 table3">
                                                {/* <div className="input-group-text">
                          <FontAwesomeIcon icon={faCalendarAlt} />
                        </div> */}
                                                <DatePicker
                                                    className="form-control btn-block"
                                                    selected={todate}
                                                    onChange={(date) => {
                                                        if (isOldDate && isDisabledDate(date)) return;
                                                        setTodate(date);
                                                    }}
                                                    filterDate={isOldDate ? (date) => !isDisabledDate(date) : undefined}
                                                    placeholderText="Select to date"
                                                    disabled={dateFilter === 'today'}
                                                    isClearable={isOldDate}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    {/* <AdvanceDataTable
                                        tableName={""}
                                        tableCell={EMPLOYEE_CAMPAIGN_DATA}
                                        tableData={campaignData}
                                        isLoading={isLoading}
                                        // isError={alert.errorMessage}
                                        filterstatus={false}
                                        pagination={true}
                                    /> */}
                                    <div className='card mt-4'>
                                        {searchData.length > 0 && dateFilter === "today" ? <h6 className='m-3'>Today Active Users : <span style={{ color: "green" }}>{searchData.length}</span></h6> : null}
                                        {searchData.length > 0 &&
                                            <table style={{ borderCollapse: 'collapse', width: '100%' }}>

                                                <thead>
                                                    <tr>
                                                        <th style={headerStyle}>Username</th>
                                                        <th style={headerStyle}>Total</th>
                                                        {channel === "sms" || channel === "email" || channel === "wp" || channel === "rcs" ? <th style={headerStyle}>Delivered</th> : null}
                                                        {channel === "sms" || channel === "voice" || channel === "wp" || channel === "rcs" ? <th style={headerStyle}>Failed</th> : null}
                                                        {channel === "voice" && <th style={headerStyle}>Success</th>}
                                                        {channel === "email" || channel === "wp" || channel === "rcs" ? <th style={headerStyle}>Sent</th> : null}
                                                        {(channel === "wp" || channel === "rcs") && <th style={headerStyle}>Read</th>}
                                                        {channel === "wp" && <th style={headerStyle}>Other</th>}
                                                        {/* {((channel === "wp" && dateFilter === "old") || channel === "sms" || (channel === "email" && dateFilter === "old") || (channel === "voice" && dateFilter === "old")) && <th style={headerStyle}>Submitted</th>} */}
                                                        {channel === "email" &&
                                                            <>
                                                                <th style={headerStyle}>Opened</th>
                                                                <th style={headerStyle}>Bounced</th>
                                                                {dateFilter === "old" && <th style={headerStyle}>Clicked</th>}
                                                            </>}
                                                    </tr>
                                                </thead>
                                                {searchData.map((x) => {
                                                    let failedDataVoice = x.User_Busy + x.Ring_Timeout + x.Network_Congestion
                                                    return (
                                                        <tbody>
                                                            <tr>
                                                                <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>
                                                                    {channel === "rcs"
                                                                        ? searchUser.find(item => item.id === x.user_id)?.username || ""
                                                                        : x.username}
                                                                </td>
                                                                {channel === "sms" && <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{x.Delivered + x.Failed + x.Submitted}</td>}
                                                                {channel === "voice" && <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{dateFilter === "today" ? x.User_Busy + x.Ring_Timeout + x.Network_Congestion + x.Success : x.Success + x.Failed + x.Submitted}</td>}
                                                                {channel === "email" && <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{dateFilter === "today" ? x.Delivered + x.Sent + x.Opened + x.Bounce : x.Delivered + x.Sent + x.Submitted + x.Opened + x.Bounce + x.Clicked}</td>}
                                                                {channel === "wp" && <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{dateFilter === "today" ? x.Delivered + x.Sent + x.Failed + x.Read : x.Delivered + x.Sent + x.Submitted + x.Failed + x.Read}</td>}
                                                                {channel === "rcs" && <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{x.delivered + x.sent + x.failed + x.read}</td>}
                                                                {channel === "sms" || channel === "email" || channel === "wp" || channel === "rcs" ? <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{channel === "rcs" ? x.delivered : x.Delivered || 0}</td> : null}
                                                                {channel === "sms" || channel === "voice" || channel === "wp" || channel === "rcs" ? <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{channel === "voice" && dateFilter === "today" ? x.User_Busy + x.Ring_Timeout + x.Network_Congestion : channel === "rcs" ? x.failed : x.Failed || 0}</td> : null}
                                                                {channel === "voice" && <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{x.Success || 0}</td>}
                                                                {channel === "email" || channel === "wp" || channel === "rcs" ? <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{channel === "rcs" ? x.sent : x.Sent || 0}</td> : null}
                                                                {(channel === "wp" || channel === "rcs") && <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{channel === "rcs" ? x.read : x.Read || 0}</td>}
                                                                {channel === "wp" && <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{x.Other || 0}</td>}
                                                                {/* {((channel === "wp" && dateFilter === "old") || channel === "sms" || (channel === "email" && dateFilter === "old") || (channel === "voice" && dateFilter === "old")) && <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{x.Submitted || 0}</td>} */}
                                                                {channel === "email" &&
                                                                    <>
                                                                        <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{x.Opened || 0}</td>
                                                                        <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{x.Bounce || 0}</td>
                                                                        {dateFilter === "old" && <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{x.Clicked || 0}</td>}
                                                                    </>}
                                                            </tr>
                                                        </tbody>
                                                    )
                                                })}
                                            </table>}

                                        {/* {channel === "voice" && voiceData.length > 0 ?
                                            <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                                                <thead>
                                                    <tr>
                                                        <th style={headerStyle}>ID</th>
                                                        <th style={headerStyle}>Username</th>
                                                        <th style={headerStyle}>Submitted</th>
                                                        <th style={headerStyle}>Success</th>
                                                        <th style={headerStyle}>Failed</th>
                                                    </tr>
                                                </thead>
                                                {voiceData.map((x) => {
                                                    return (
                                                        <tbody>
                                                            <tr>
                                                                <td style={{ fontSize: "13px", padding: ".6rem" }}><b>{x.user_id}</b></td>
                                                                <td style={{ fontSize: "13px", padding: ".6rem" }}><b>{x.username}</b></td>
                                                                <td style={{ fontSize: "13px", padding: ".6rem" }}><b>{x.total_submitted}</b></td>
                                                                <td style={{ fontSize: "13px", padding: ".6rem" }}><b>{x.total_success}</b></td>
                                                                <td style={{ fontSize: "13px", padding: ".6rem" }}><b>{x.total_failed}</b></td>
                                                            </tr>
                                                        </tbody>
                                                    )
                                                })}
                                            </table> : null}

                                        {channel === "email" && emailData.length > 0 ?
                                            <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                                                <thead>
                                                    <tr>
                                                        <th style={headerStyle}>ID</th>
                                                        <th style={headerStyle}>Username</th>
                                                        <th style={headerStyle}>Sent</th>
                                                        <th style={headerStyle}>Submitted</th>
                                                        <th style={headerStyle}>Delivered</th>
                                                        <th style={headerStyle}>Opened</th>
                                                        <th style={headerStyle}>Bounced</th>
                                                        <th style={headerStyle}>Clicked</th>
                                                    </tr>
                                                </thead>
                                                {emailData.map((x) => {
                                                    return (
                                                        <tbody>
                                                            <tr>
                                                                <td style={{ fontSize: "13px", padding: ".6rem" }}><b>{x.user_id}</b></td>
                                                                <td style={{ fontSize: "13px", padding: ".6rem" }}><b>{x.username}</b></td>
                                                                <td style={{ fontSize: "13px", padding: ".6rem" }}><b>{x.total_sent}</b></td>
                                                                <td style={{ fontSize: "13px", padding: ".6rem" }}><b>{x.total_submitted}</b></td>
                                                                <td style={{ fontSize: "13px", padding: ".6rem" }}><b>{x.total_delivered}</b></td>
                                                                <td style={{ fontSize: "13px", padding: ".6rem" }}><b>{x.total_opened}</b></td>
                                                                <td style={{ fontSize: "13px", padding: ".6rem" }}><b>{x.total_bounced}</b></td>
                                                                <td style={{ fontSize: "13px", padding: ".6rem" }}><b>{x.total_clicked}</b></td>
                                                            </tr>
                                                        </tbody>
                                                    )
                                                })}
                                            </table> : null} */}

                                    </div>
                                    {/* <div className="d-flex justify-content-end mr-2">
                                        <small className="mb-2">
                                            Total cost: {parseFloat(totalCost).toFixed(2)}
                                        </small>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </AdminLayout>
        </div>
    )
}

export default ApiReport
